import React from 'react';

export function TextField({
  label,
  id,
  error,
  hint,
  className = '',
  inputClassName = '',
  ...inputProps
}) {
  const inputId = id || (label ? `ds-field-${label.replace(/\s+/g, '-').toLowerCase()}` : undefined);

  return (
    <div className={`ds-field ${className}`.trim()}>
      {label ? (
        <label className="ds-field__label" htmlFor={inputId}>
          {label}
        </label>
      ) : null}
      <input id={inputId} className={`ds-field__input ${inputClassName}`.trim()} {...inputProps} />
      {error ? (
        <p className="ds-field__error" role="alert">
          {error}
        </p>
      ) : null}
      {hint && !error ? <p className="ds-field__hint">{hint}</p> : null}
    </div>
  );
}

export function TextArea({ label, id, error, rows = 3, className = '', ...props }) {
  const inputId = id || (label ? `ds-field-${label.replace(/\s+/g, '-').toLowerCase()}` : undefined);

  return (
    <div className={`ds-field ${className}`.trim()}>
      {label ? (
        <label className="ds-field__label" htmlFor={inputId}>
          {label}
        </label>
      ) : null}
      <textarea id={inputId} className="ds-field__input ds-field__textarea" rows={rows} {...props} />
      {error ? (
        <p className="ds-field__error" role="alert">
          {error}
        </p>
      ) : null}
    </div>
  );
}

export function Select({ label, id, options = [], placeholder, className = '', ...selectProps }) {
  const inputId = id || (label ? `ds-field-${label.replace(/\s+/g, '-').toLowerCase()}` : undefined);

  return (
    <div className={`ds-field ${className}`.trim()}>
      {label ? (
        <label className="ds-field__label" htmlFor={inputId}>
          {label}
        </label>
      ) : null}
      <select id={inputId} className="ds-field__input ds-field__select" {...selectProps}>
        {placeholder ? (
          <option value="" disabled>
            {placeholder}
          </option>
        ) : null}
        {options.map((opt) => (
          <option key={opt.value} value={opt.value}>
            {opt.label}
          </option>
        ))}
      </select>
    </div>
  );
}

export default TextField;
